import React, {useState} from "react";
import ExpansionPanel from "../../../../../../../../ui/ExpandPanel/ExpansionPanel";
import ExpansionPanelSummary from "../../../../../../../../ui/ExpandPanel/ExpansionPanelSummary";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ExpansionPanelDetails from "../../../../../../../../ui/ExpandPanel/ExpansionPanelDetails";
import QuestionDetails from "../QuestionDetails";
import DeleteConfirmationModal from "../../../../../../../../ui/DeleteConfirmationModal";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

export const QuestionItem = ({question,
                               expandedQuestion,
                               setExpandedQuestion,
                               deleteIcon, onQuestionDelete,
                               editIcon, onQuestionEdit}) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  return (
    <div>
    <DeleteConfirmationModal
      modalText="Удалить вопрос?"
      open={deleteModalOpen}
      onConfirm={() => onQuestionDelete(question.id)}
      handleClose={() => setDeleteModalOpen(false)}
    />
    <ExpansionPanel
      square
      expanded={expandedQuestion === question.id}
      onChange={() => {
        if (expandedQuestion === question.id) {
          setExpandedQuestion(-1);
        } else {
          setExpandedQuestion(question.id);
        }
      }}>
      <ExpansionPanelSummary>
        <div style={{ display: "flex" }}>
          {expandedQuestion === question.id ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
          <Typography><strong>Вопрос {question.order}. </strong>{question.question}</Typography>
        </div>
        <div style={{ paddingRight: "16px" }}>
          <Tooltip title="Редактировать" placement="top-start">
            <IconButton
              size="small"
              onClick={() => onQuestionEdit(question.id)}
            >
              {editIcon}
            </IconButton>
          </Tooltip>
          <Tooltip title="Удалить" placement="top-start">
            <IconButton size="small"
                        onClick={() => setDeleteModalOpen(true)}>
              {deleteIcon}</IconButton>
          </Tooltip>
        </div>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <QuestionDetails question={question}/>
      </ExpansionPanelDetails>
    </ExpansionPanel>
    </div>
  );
}

export default QuestionItem;
